export enum RouterPaths {
  INDEX = '/',
  TOURNAMENT = '/tournaments/:id',
  TEAMS = '/tournaments/:id/teams',
  TEAM = '/tournaments/:id/teams/:teamId',
  TEAM_EDIT = '/tournaments/:id/teams/:teamId/edit',
};
